module.exports = __webpack_public_path__ + "img/selected4-min.2e1c1a84.png";